import { useCallback, useRef } from 'react';

export const useFocusTextarea = () => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const focusTextarea = useCallback(() => {
    // setTimeout needed: focus after React state flush
    setTimeout(() => textareaRef.current?.focus(), 0);
  }, []);

  return { textareaRef, focusTextarea };
};
